import React from "react";
import "./../Homepage.css";
import "./weekly.css";

import 'react-slideshow-image/dist/styles.css';
import { Slide } from 'react-slideshow-image';

import model from "./../models/ship_in_bottle.glb";
import print_1_stl from "./../models/ship_in_a_bottle.stl";
import print_2_stl from "./../models/ship_in_bottle_short.stl";

import bottle_cut from "./../photos/3dp/bottle_cut.webp";
import bottle_hex_one from "./../photos/3dp/bottle_hex_one.webp";
import bottle_hex from "./../photos/3dp/bottle_hex.webp";

import boat_cad from "./../photos/3dp/boat_cad.webp";
import hull_cad from "./../photos/3dp/hull_cad.webp";

import bottle_hex_ship from "./../photos/3dp/bottle_hex_ship.webp";
import bottle_hex_ship_2 from "./../photos/3dp/bottle_hex_ship_2.webp";

import print_1_cad from "./../photos/3dp/print_1_cad.webp";
import print_1_progress from "./../photos/3dp/print_1_progress.webp";
import print_1_done from "./../photos/3dp/print_1_done.webp";
import print_1_angle from "./../photos/3dp/print_1_angle.webp";
import print_1_front from "./../photos/3dp/print_1_front.webp";
import print_1_error from "./../photos/3dp/print_1_error.webp";

import print_2_cad from "./../photos/3dp/print_2_cad.webp";
import print_error from "./../photos/3dp/print_error.webp";
import print_2_progress from "./../photos/3dp/print_2_progress.webp";
import print_2_done from "./../photos/3dp/print_2_done.webp";
import print_2_front from "./../photos/3dp/print_2_front.webp";
import print_2_support from "./../photos/3dp/print_2_support.webp";

import mouse_top from "./../photos/3dp/mouse_top.webp";
import mouse_side from "./../photos/3dp/mouse_side.webp";

const model2 = "https://www.dropbox.com/scl/fi/a1nb99bqf7oswomvh9yaz/mouse_mesh.glb?rlkey=c5ecuicl3vdi6fgywpy7uuwrj&raw=1";

const slide1 = [{image: print_1_cad, caption: "CAD for first print"},
                {image: print_1_progress, caption: "Progress on first print"},
                {image: print_1_done, caption: "Finished first print"},
                {image: print_1_angle, caption: "Angle view of first print"},
                {image: print_1_front, caption: "Front view of first print"},
                {image: print_1_error, caption: "View of unsupported print material"},];

const slide2 = [{image: print_2_cad, caption: "CAD for final model"},
                {image: print_error, caption: "Printing error, misalignment"},
                {image: print_2_progress, caption: "Progress on retried print"},
                {image: print_2_done, caption: "Finished final print"},
                {image: print_2_front, caption: "Bottom view of print with support material"},
                {image: print_2_support, caption: "Final printed model with removed support material"},];


const Week4 = (props) => {
    return (
      <div className="HP-module">
        <div className="HP-subtitle">Week 4</div>
        <div className="HP-body">
            In this week we learned about 3D printing and scanning. As I've mentioned in previous weeks, my CAD skills are very beginner so I was looking 
            forward to working on designing my print. The goal for the assignment this week is to make something that cannot be made subtractively, or a print 
            that can only be done by printing, not by cutting or milling. With my passion for sailing, I immediately thought of a classic example of a non-subtractive 
            object: a ship in a bottle. Using this idea as inspiration, I began cadding my design.
        </div>
        <div className="HP-spacer" />
        <div className="HP-flex">
            <div className="HP-half HP-body">
                The first thing I did was design the "bottle". I decided the best way to make a visually interesting print (since printing materials are usually opaque), 
                was to cut out pieces from the bottle assembly so that you can see inside from all sides, as well as leaving the ends open for a better view. I started by 
                making the general shape, rounding the edges of a rectangular prism and removing the middle to leave space for the ship. Next I sketched the cutout design 
                for the sides of the prism, for which i decided to use hexagons due to their nice properties when making an array. I made an array of these hexagons and extruded them,
                finally cutting them from the prism to make the new face design. I then recreated this extrusion in the correct orientation for each face of the prism, and cut them 
                out to make the complete prism shape.
            </div>
            <div className="HP-photoContent HP-half">
                <div className="HP-photoObject">
                    <img src={bottle_cut} className="HP-smallPhoto" style={{marginTop:"20px"}}/>
                    <div className="HP-caption">Bottle shape cutout</div>
                </div>
                <div className="HP-flex">
                    <div className="HP-photoObject">
                        <img src={bottle_hex_one} className="HP-scalePhoto" />
                        <div className="HP-caption">Hex cutout on one face</div>
                    </div>
                    <div className="HP-photoObject">
                        <img src={bottle_hex} className="HP-scalePhoto" />
                        <div className="HP-caption">Hex cutout on all faces</div>
                    </div>
                </div>
            </div>
        </div>
        <div className="HP-spacer" />
        <div className="HP-flex">
            <div className="HP-photoContent HP-half">
                <div className="HP-photoObject">
                    <img src={hull_cad} className="HP-smallPhoto" style={{marginTop:"20px"}}/>
                    <div className="HP-caption">CAD design of the hull</div>
                </div>
                <div className="HP-photoObject">
                    <img src={boat_cad} className="HP-smallPhoto"/>
                    <div className="HP-caption">CAD design of the boat</div>
                </div>
            </div>
            <div className="HP-half HP-body">
                The next step in the design was to make the "ship". I wanted to keep the ship fairly simple so that it could serve as structural support to the top face of the 
                bottle when being printed (this actually was not the case, but it was the motivation). I made a simple sketch of the hull, extruded it, and added some simple shapes to 
                model the sails. Once the simplified ship was built, I added it inside of the bottle housing, making sure it was aligned so that the bottom was rooted in the bottom face 
                of the bottle and the top of the mast was in the top face (as support). Once the assembly was combined, I decided to add support to the ends of the bottle assembly so that 
                the edges would be sturdier in a print. I made a new cut of the same hollow rectangular prism without the hex lattice, and added a small section on both ends to improve 
                the structural integrity. 
            </div>
        </div>
        <div className="HP-photoContainer">
            <div className="HP-photoObject">
                <img src={bottle_hex_ship} className="HP-medPhoto"/>
                <div className="HP-caption">CAD design of the assembly with hex design</div>
            </div>
            <div className="HP-photoObject">
                <img src={bottle_hex_ship_2} className="HP-medPhoto"/>
                <div className="HP-caption">CAD design of the assembly with extra support</div>
            </div>
        </div>
        <div className="HP-body">
            At this point I was almost ready to print and test my first design. While analyzing my design for potential faults, however, I realized that the hexagon design would 
            mean that the printer could not print in straight lines across the entire assembly, specifically on the top, and could not take advantage of the bridging stability when 
            connecting a strand between two supports. I figured that this meant the design was bound to fail under gravity while printing, and settled on changing out the hexagons for 
            diamonds, as a diamond pattern would allow strands to stretch unbent between both sides, making the bridging properties (theoretically) ensure proper printing. Because of 
            a nice parametric design in my CAD project, it was actually very easy to make this change, and soon I had another model made with diamond cutouts, all ready to print. The 
            STL file of this design can be found <a href={print_1_stl}>here</a>. I used the Prusa printer, with no supports, and let the job execute. Once the print was done, I found an almost 
            successful print waiting for me. The main problem was the lack of support on the top of the bottle structure, as while I expected the printer to print straight lines across the 
            top of the object, it instead tried to zig-zag between the bends of the diamonds. This led to a lack of support, and the top, while still existing, was a spaghetti mess. Here 
            are some pictured of the new diamond cutout design and the partially failed print. 
        </div>
        <div className="HP-spacer" />
        <Slide>
          {slide1.map((image) => <div className="HP-slideDiv" key={image.caption}>
              <div className="HP-photoObject">
                <img src={image.image} className="HP-slidePhotoLarge"/>
                <div className="HP-caption">{image.caption}</div>
              </div>
            </div>)}
        </Slide>
        <div className="HP-spacer" />
        <div className="HP-body">
            With the failure of the first print, I decided that instead of brainstorming ways to prevent the top of the bottle from collapsing and making spaghetti 
            when printing, I could just print the design with the open ends of the bottle on the top and the bottom. This way I would not have to worry about making a 
            face of the bottle stretching across any gap. I could build the bottle and the ship in this way and it should fix the issues with very minimal design change. 
            The only changes needed was a small angle change to the back of the boat to prevent a 90 degree overhang and a slight shift of the boat position so that 
            the mast would be supported by the top of the bottle in the new orientation. To fix the latter issue I made the bottle slightly shorter, and the whole print 
            slightly larger to compensate. I then reprinted the design, which initially failed (seemingly due to printer alignment, see photo below). I restarted the job with the same file, 
            and it came out successfully!. The updated CAD file can be found <a href={print_2_stl}>here</a> and below 
            are some photos of the new print as well as an interactive model of the final design. 
        </div>
        <div className="HP-spacer" />
        <Slide>
          {slide2.map((image) => <div className="HP-slideDiv" key={image.caption}>
              <div className="HP-photoObject">
                <img src={image.image} className="HP-slidePhotoLarge"/>
                <div className="HP-caption">{image.caption}</div>
              </div>
            </div>)}
        </Slide>
        <div style={{display: "flex", justifyContent:"center"}}>
            <model-viewer src={model} camera-controls shadow-intensity="2" exposure="0.49" class="weekly-model"/>
        </div>
        <div className="HP-spacer" />
        <div className="HP-body">
            The second goal for the week was to scan something using the 3D scanner and obtain a model of it. For this assignment 
            I tried scanning several things, with varying degrees of success. I first tried to scan my class ring, which turned out 
            to be too small to be accurately picked up by the scanner. Next I tried to scan my whole hand, which also didn't work well 
            as I could not keep my hand still enough for the scanner or rotate it well enough. This led to the scan calibration failing 
            and my hand was a blurry mess on the software. Finally, opting for simplicity, I scanned a computer mouse. This turned out to be 
            the right size and complexity, and the scanner did a good job of modeling the mouse. Below are some images of the scan, and the 
            file of the scan can be found <a href={model2} >here</a>.
        </div>
        <div className="HP-photoContainer">
            <div className="HP-photoObject">
                <img src={mouse_side} className="HP-medPhoto"/>
                <div className="HP-caption">Side view of scanned mouse</div>
            </div>
            <div className="HP-photoObject">
                <img src={mouse_top} className="HP-medPhoto"/>
                <div className="HP-caption">Top view of scanned mouse</div>
            </div>
        </div>
      </div>
    )
}

export default Week4;